import React from 'react'
import { graphql } from 'gatsby'
import { Alert } from 'reactstrap'
import axios from 'axios'
import IconSocial from '../components/iconsocial'
import Layout from '../components/layout'
// import InsideHeaderMap from '../components/insideheadermap'

import ReactMarkdown from 'react-markdown'
import InsideHeader from '../components/insideheader'

class ContactTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      props: props,
      page: props.data.dataJson,
      name: '',
      company: '',
      email: '',
      mobile: '',
      message: '',
      alertVisible: false,
      alertMessage: '',
      alertColor: 'success',
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onDismiss = this.onDismiss.bind(this)
  }

  handleChange(event) {
    var formvar = {}
    formvar[event.target.name] = event.target.value
    this.setState(formvar)
  }

  onDismiss() {
    this.setState({ alertVisible: false, alertMessage: '' })
  }

  handleSubmit(event) {
    var formData = new FormData()
    const that = this
    formData.set('name', this.state.name)
    formData.set('company', this.state.company)
    formData.set('email', this.state.email)
    formData.set('mobile', this.state.mobile)
    formData.set('message', this.state.message)
    axios
      .post('https://www.indusequitypartners.com/processform.php', formData, {
        header: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      })
      .then(function(response) {
        console.log(response)
        if (response.data.hasOwnProperty('success')) {
          that.setState({
            alertVisible: true,
            alertColor: 'success',
            alertMessage: response.data.success,
            name: '',
            email: '',
            mobile: '',
            message: '',
          })
        } else if (response.data.hasOwnProperty('error')) {
          that.setState({
            alertVisible: true,
            alertColor: 'error',
            alertMessage: response.data.error,
          })
        }
      })
      .catch(function(error) {
        console.log(error)
        that.setState({
          alertVisible: true,
          alertColor: 'error',
          alertMessage: error,
        })
      })
    event.preventDefault()
  }

  render() {
    return (
      <Layout>
        {/* <InsideHeaderMap
          pageTitle={this.state.page.title}
          pageSubTitle={this.state.page.subTitle}
          pageBackground={this.state.page.titleBackground}
        /> */}
        <InsideHeader
          pageTitle={this.state.page.title}
          pageSubTitle={this.state.page.subTitle}
          pageSlug={this.state.page.slug}
          headerImage={this.state.page.titleBackground}
        />
        <main className="main-content">
          <section className="section">
            <div className="container">
              <div className="row">
                <div className="col-md-11 mx-auto">
                  <div className="container">
                    <form
                      name="sendQuery"
                      className="form-row input-border needs-validation"
                      noValidate={true}
                      action="#"
                      onSubmit={this.handleSubmit}
                    >
                      <div className="col-lg-6">
                        <h3>Contact Us</h3>
                        <br />
                        <div className="col-12">
                          <Alert
                            color={this.state.alertColor}
                            isOpen={this.state.alertVisible}
                            toggle={this.onDismiss}
                          >
                            {this.state.alertMessage}
                          </Alert>
                        </div>
                        <div className="form-row">
                          <div className="form-group col-12">
                            <input
                              className="form-control form-control-lg shadow btn-round"
                              type="text"
                              name="name"
                              placeholder="Name"
                              onChange={this.handleChange}
                              required={true}
                            />
                          </div>
                          <div className="form-group col-12">
                            <input
                              className="form-control form-control-lg shadow btn-round"
                              type="text"
                              name="company"
                              placeholder="Company"
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <input
                              className="form-control form-control-lg shadow btn-round"
                              type="email"
                              name="email"
                              placeholder="Email"
                              onChange={this.handleChange}
                              required={true}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <input
                              className="form-control form-control-lg shadow btn-round"
                              type="text"
                              name="mobile"
                              placeholder="Mobile"
                              onChange={this.handleChange}
                              required={true}
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <textarea
                            className="form-control form-control-lg shadow"
                            style={{ borderRadius: '2rem' }}
                            rows="4"
                            placeholder="Message"
                            name="message"
                            onChange={this.handleChange}
                            required={true}
                          />
                        </div>

                        <button
                          className="btn btn-lg btn-primary btn-round shadow"
                          type="submit"
                        >
                          Send message
                        </button>
                      </div>

                      <div className="col-lg-5 ml-auto text-center text-lg-left">
                        <hr className="d-lg-none" />
                        <h3>Write To Us</h3>
                        <br />
                        {this.state.page.contents.map((item, index) => (
                          <>
                            {item.heading ? (
                              <div>
                                <ReactMarkdown
                                  source={item.heading}
                                  escapeHtml={false}
                                />
                                <ReactMarkdown
                                  source={item.content}
                                  escapeHtml={false}
                                />
                              </div>
                            ) : (
                              <IconSocial
                                itemHeading={item.heading}
                                itemContent={item.content}
                                itemImage={item.image}
                              />
                            )}
                          </>
                        ))}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </Layout>
    )
  }
}

export const query = graphql`
  query($slug: String!) {
    dataJson(fields: { slug: { eq: $slug } }) {
      title
      subTitle
      titleBackground
      contents {
        heading
        image
        content
        heading
      }
    }
  }
`

export default ContactTemplate
